import React from 'react';

export default function FoxEarsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="12.39,23.36 4.17,19.95 9.84,6.26 18.06,9.66" fill="#9D4C20" />
      <polygon points="36.32,19.95 28.1,23.36 22.43,9.66 30.65,6.26" fill="#9D4C20" />
      <polygon points="6.19,24.81 2.0,20.61 8.29,14.32 12.48,18.52" fill="#9D4C20" />
      <polygon points="38.0,20.61 33.81,24.81 27.52,18.52 31.71,14.32" fill="#9D4C20" />
      <polygon points="13.28,23.8 7.8,21.53 12.34,10.58 17.81,12.84" fill="#9D4C20" />
      <polygon points="7.8,21.53 6.91,21.09 11.45,10.13 12.34,10.58" fill="#48220E" opacity="0.95" />
      <polygon points="34.47,21.53 28.99,23.8 24.45,12.84 29.93,10.58" fill="#9D4C20" />
      <polygon points="28.99,23.8 34.47,21.53 33.58,21.09 28.1,23.36" fill="#48220E" opacity="0.95" />
      <polygon points="28.99,23.8 28.1,23.36 23.56,12.4 24.45,12.84" fill="#48220E" opacity="0.95" />
      <polygon points="33.42,24.85 9.7,24.85 9.7,21.88 33.42,21.88" fill="#9D4C20" />
      <polygon points="9.7,24.85 33.42,24.85 31.64,23.96 7.92,23.96" fill="#48220E" opacity="0.95" />
      <polygon points="9.7,24.85 7.92,23.96 7.92,20.99 9.7,21.88" fill="#48220E" opacity="0.95" />
      <polygon points="36.38,33.74 33.42,33.74 33.42,21.88 36.38,21.88" fill="#9D4C20" />
      <polygon points="33.42,33.74 36.38,33.74 34.6,32.85 31.64,32.85" fill="#48220E" opacity="0.95" />
      <polygon points="33.42,33.74 31.64,32.85 31.64,20.99 33.42,21.88" fill="#48220E" opacity="0.95" />
      <polygon points="9.7,33.74 6.73,33.74 6.73,21.88 9.7,21.88" fill="#9D4C20" />
      <polygon points="6.73,33.74 9.7,33.74 7.92,32.85 4.95,32.85" fill="#48220E" opacity="0.95" />
      <polygon points="6.73,33.74 4.95,32.85 4.95,20.99 6.73,21.88" fill="#48220E" opacity="0.95" />
    </svg>
  );
}
